import service from './baseService';
import { getCompanyId } from '../config';

export const getTripSettingsService = (companyId) => {
    return service.get(`/customer/accountSettings`, { params: { companyId: companyId || getCompanyId() } });
};
